import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Building2, CalendarDays, Star, Image, Store } from 'lucide-react';

const navItems = [
  { icon: Building2, label: 'Profile', path: '/client' },
  { icon: CalendarDays, label: 'Posts', path: '/calendar' },
  { icon: Star, label: 'Reviews', path: '/reviews' },
  { icon: Store, label: 'Google', path: '/google-business' },
  { icon: Image, label: 'Images', path: '/images' }
];

const BottomNavWebview = () => {
  const history = useHistory();
  const location = useLocation();
  const isTruthyQueryParam = (value = '') =>
    ['1', 'true', 'yes'].includes(String(value).toLowerCase());

  const currentParams = new URLSearchParams(location.search);
  const shouldKeepWebview = isTruthyQueryParam(currentParams.get('webview'));
  const shouldKeepShowmenu = isTruthyQueryParam(currentParams.get('showmenu'));

  const buildPathWithCurrentParams = (path) => {
    if (!shouldKeepWebview) return path;

    const [pathname, rawSearch = ''] = path.split('?');
    const params = new URLSearchParams(rawSearch);
    params.set('webview', '1');

    if (shouldKeepShowmenu) {
      params.set('showmenu', '1');
    }

    return `${pathname}?${params.toString()}`;
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-primary border-t border-primary-foreground/15 pb-[env(safe-area-inset-bottom)]">
      <div className="flex items-center justify-around h-16 px-1">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() =>
                history.push(buildPathWithCurrentParams(item.path))
              }
              className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-colors ${
                isActive
                  ? 'text-primary-foreground'
                  : 'text-primary-foreground/50'
              }`}>
              <item.icon
                className={`h-5 w-5 ${isActive ? 'stroke-[2.5]' : ''}`}
              />
              <span
                className={`text-[10px] font-medium ${
                  isActive ? 'font-semibold' : ''
                }`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavWebview;
